/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState } from "react";
import {
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    IconButton,
    Select,
    MenuItem,
    Box,
    Tab,
    Tabs,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import SearchBar from "../../components/SearchBar";
import SwitchToggle from "../../components/SwitchToggle";
import CampaignOutlinedIcon from "@mui/icons-material/CampaignOutlined";
import AttachMoneyOutlinedIcon from "@mui/icons-material/AttachMoneyOutlined";
import TrendingUpOutlinedIcon from "@mui/icons-material/TrendingUpOutlined";
import GroupsOutlinedIcon from "@mui/icons-material/GroupsOutlined";

/* ── Tab helpers ── */
interface TabPanelProps {
    children?: React.ReactNode;
    index: number;
    value: number;
}
function CustomTabPanel({ children, value, index }: TabPanelProps) {
    return (
        <div hidden={value !== index}>
            {value === index && <>{children}</>}
        </div>
    );
}
function a11yProps(index: number) {
    return { id: `campaign-tab-${index}`, "aria-controls": `campaign-tabpanel-${index}` };
}

const VendorCampaigns = () => {
    const navigate = useNavigate();
    const [activeTab, setActiveTab] = useState(0);
    const [searchTerm, setSearchTerm] = useState("");

    const [campaigns, setCampaigns] = useState([
        {
            id: 1,
            vendor: {
                id: "VND-00231",
                storeName: "ABC Lifestyle Store",
                name: "Rahul Sharma",
                email: "vendor@abclifestyle.com",
                phone: "+91 98765 43210",
                image: "/static/images/user_placeholder.png",
            },
            name: "Diwali Mega Sale",
            type: "Discount",
            discountValue: "15%",
            startDate: "20 Nov 2025",
            endDate: "30 Nov 2025",
            status: "Pending",
            active: true,
        },
        {
            id: 2,
            vendor: {
                id: "VND-00456",
                storeName: "Urban Mart",
                name: "Ankit Verma",
                email: "contact@urbanmart.com",
                phone: "+91 99887 66554",
                image: "/static/images/user_placeholder.png",
            },
            name: "Free Shipping Weekend",
            type: "Free Shipping",
            discountValue: "-",
            startDate: "15 Dec 2025",
            endDate: "17 Dec 2025",
            status: "Accepted",
            active: true,
        },
        {
            id: 3,
            vendor: {
                id: "VND-00789",
                storeName: "StyleHub",
                name: "Priya Mehta",
                email: "priya@stylehub.com",
                phone: "+91 98001 12345",
                image: "/static/images/user_placeholder.png",
            },
            name: "Winter Flash Sale",
            type: "Flash Sale",
            discountValue: "25%",
            startDate: "01 Jan 2026",
            endDate: "07 Jan 2026",
            status: "Rejected",
            active: false,
        },
        {
            id: 4,
            vendor: {
                id: "VND-00102",
                storeName: "Luxe Couture",
                name: "Meena Iyer",
                email: "meena@luxecouture.ae",
                phone: "+971 505 112233",
                image: "/static/images/user_placeholder.png",
            },
            name: "Eid Special Discount",
            type: "Discount",
            discountValue: "20%",
            startDate: "25 Mar 2026",
            endDate: "05 Apr 2026",
            status: "Pending",
            active: true,
        },
        {
            id: 5,
            vendor: {
                id: "VND-00314",
                storeName: "TechZone UAE",
                name: "Sanjay Patel",
                email: "sanjay@techzone.ae",
                phone: "+971 502 334455",
                image: "/static/images/user_placeholder.png",
            },
            name: "Gadget Bonanza",
            type: "Bundle Deal",
            discountValue: "10%",
            startDate: "10 Feb 2026",
            endDate: "20 Feb 2026",
            status: "Accepted",
            active: true,
        },
        {
            id: 6,
            vendor: {
                id: "VND-00527",
                storeName: "BeautyBliss",
                name: "Fatima Al-Hassan",
                email: "fatima@beautybliss.ae",
                phone: "+971 508 667788",
                image: "/static/images/user_placeholder.png",
            },
            name: "Skincare Summer Sale",
            type: "Discount",
            discountValue: "30%",
            startDate: "01 Jun 2026",
            endDate: "15 Jun 2026",
            status: "Rejected",
            active: false,
        },
        {
            id: 7,
            vendor: {
                id: "VND-00638",
                storeName: "Home & Living Co.",
                name: "Omar Khalid",
                email: "omar@homeliving.ae",
                phone: "+971 501 998877",
                image: "/static/images/user_placeholder.png",
            },
            name: "Ramadan Home Deals",
            type: "Flash Sale",
            discountValue: "35%",
            startDate: "01 Mar 2026",
            endDate: "30 Mar 2026",
            status: "Pending",
            active: false,
        },
        {
            id: 8,
            vendor: {
                id: "VND-00741",
                storeName: "KidsWorld",
                name: "Neha Gupta",
                email: "neha@kidsworld.ae",
                phone: "+971 507 223344",
                image: "/static/images/user_placeholder.png",
            },
            name: "Back to School Offer",
            type: "Discount",
            discountValue: "12%",
            startDate: "15 Aug 2026",
            endDate: "31 Aug 2026",
            status: "Accepted",
            active: true,
        },
        {
            id: 9,
            vendor: {
                id: "VND-00855",
                storeName: "SportsGear Pro",
                name: "Arjun Nair",
                email: "arjun@sportsgear.ae",
                phone: "+971 503 556677",
                image: "/static/images/user_placeholder.png",
            },
            name: "Fitness Month Bundle",
            type: "Bundle Deal",
            discountValue: "18%",
            startDate: "01 Apr 2026",
            endDate: "30 Apr 2026",
            status: "Rejected",
            active: false,
        },
    ]);


    const handleStatusChange = (id: number, newStatus: string) => {
        setCampaigns((prev) =>
            prev.map((c) => (c.id === id ? { ...c, status: newStatus } : c))
        );
    };

    const tabStatuses = ["Pending", "Accepted", "Rejected"];

    const filteredCampaigns = (status: string) =>
        campaigns.filter(
            (c) =>
                c.status === status &&
                (c.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
                    c.vendor.name.toLowerCase().includes(searchTerm.toLowerCase()))
        );

    /* ── Shared table renderer ── */
    const renderTable = (rows: typeof campaigns) => (
        <TableContainer className="table_container">
            <Table>
                <TableHead>
                    <TableRow>
                        <TableCell>Sr. No</TableCell>
                        <TableCell>Vendor</TableCell>
                        <TableCell>Campaign</TableCell>
                        <TableCell>Type</TableCell>
                        <TableCell>Discount</TableCell>
                        <TableCell>Duration</TableCell>
                        <TableCell>Status</TableCell>
                        <TableCell>Active</TableCell>
                        <TableCell>Action</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {rows.length > 0 ? (
                        rows.map((item, index) => (
                            <TableRow hover key={item.id}>
                                <TableCell>{index + 1}</TableCell>

                                <TableCell>
                                    <div className="vendor_td">
                                        <img src={item.vendor.image} alt="Vendor" />
                                        <div>
                                            <p>{item.vendor.name}</p>
                                            <small>{item.vendor.email}</small>
                                            <span>{item.vendor.phone}</span>
                                        </div>
                                    </div>
                                </TableCell>

                                <TableCell>{item.name}</TableCell>
                                <TableCell>{item.type}</TableCell>
                                <TableCell>{item.discountValue}</TableCell>
                                <TableCell>{item.startDate} - {item.endDate}</TableCell>

                                {/* Status Dropdown */}
                                <TableCell className="form">
                                    <Select
                                        size="small"
                                        value={item.status}
                                        onChange={(e) => handleStatusChange(item.id, e.target.value)}
                                    >
                                        <MenuItem value="Pending">Pending</MenuItem>
                                        <MenuItem value="Accepted">Accepted</MenuItem>
                                        <MenuItem value="Rejected">Rejected</MenuItem>
                                    </Select>
                                </TableCell>

                                <TableCell>
                                    <SwitchToggle checked={item.active} />
                                </TableCell>

                                <TableCell>
                                    <div className="table_actions v2">
                                        <IconButton onClick={() => navigate("/discount/view")}>
                                            <img src="/static/images/eye_icon.svg" alt="View" />
                                        </IconButton>
                                        <IconButton>
                                            <img src="/static/images/trash2_icon.svg" alt="Delete" />
                                        </IconButton>
                                    </div>
                                </TableCell>
                            </TableRow>
                        ))
                    ) : (
                        <TableRow>
                            <TableCell colSpan={9} align="center">
                                No campaigns found.
                            </TableCell>
                        </TableRow>
                    )}
                </TableBody>
            </Table>
        </TableContainer>
    );

    return (
        <>
            <div className="main_title">
                <h1>Vendor Campaigns</h1>
                <p>
                    <button onClick={() => navigate("/dashboard")}>Dashboard</button> - Marketing Suite
                </p>
            </div>

            {/* Stats */}
            <div className="stats_boxes gap_m">
                <a className="cards">
                    <div className="data_top">
                        <h2>5<p>Active Campaigns</p></h2>
                        <figure className="sucess">
                            <CampaignOutlinedIcon fontSize="large" />
                        </figure>
                    </div>
                </a>

                <a className="cards">
                    <div className="data_top">
                        <h2>AED 323,000<p>Total Budget</p></h2>
                        <figure className="blue">
                            <AttachMoneyOutlinedIcon fontSize="large" />
                        </figure>
                    </div>
                </a>

                <a className="cards">
                    <div className="data_top">
                        <h2>AED 188,900<p>Total Spent</p></h2>
                        <figure className="purple">
                            <TrendingUpOutlinedIcon fontSize="large" />
                        </figure>
                    </div>
                </a>

                <a className="cards">
                    <div className="data_top">
                        <h2>125K<p>Avg. Reach</p></h2>
                        <figure className="warning">
                            <GroupsOutlinedIcon fontSize="large" />
                        </figure>
                    </div>
                </a>
            </div>

            {/* Campaign Table with Tabs */}
            <div className="cards mt_20">
                {/* Tabs */}
                <div className="table_header">
                    <div className="left_s">
                        <Box className="custom_tabs1" sx={{ width: "100%" }}>
                            <Tabs
                                value={activeTab}
                                onChange={(_e, val) => setActiveTab(val)}
                                className="custom_tabs_links"
                            >
                                <Tab
                                    label={`Pending (${campaigns.filter((c) => c.status === "Pending").length})`}
                                    {...a11yProps(0)}
                                />
                                <Tab
                                    label={`Accepted (${campaigns.filter((c) => c.status === "Accepted").length})`}
                                    {...a11yProps(1)}
                                />
                                <Tab
                                    label={`Rejected (${campaigns.filter((c) => c.status === "Rejected").length})`}
                                    {...a11yProps(2)}
                                />
                            </Tabs>
                        </Box>
                    </div>
                    <div className="right_s">
                        <SearchBar
                            searchTerm={searchTerm}
                            setDebouncedSearchTerm={setSearchTerm}
                            placeholder="Search campaigns..."
                        />
                    </div>
                </div>

                {tabStatuses.map((status, idx) => (
                    <CustomTabPanel key={status} value={activeTab} index={idx}>
                        {renderTable(filteredCampaigns(status))}
                    </CustomTabPanel>
                ))}
            </div>
        </>
    );
};

export default VendorCampaigns;

